import axios from 'axios';

const getQuestions = async () => {
  try {
    const {
      data: { data },
    } = await axios.get('/api/getMenteeQuestions');
    return data;
  } catch (e) {
    console.error(e);
  }
};

export const MenteeService = {
  getQuestions,
};
